import React, { useState } from 'react';
import isLength from 'validator/es/lib/isLength';
import Modal from '@avtopro/modal';
import Button from '@avtopro/button';
import withValidation, { Rule } from '@avtopro/validator';
import cartResx from 'Resx/Cart/Cart.resx';
import homeResx from 'Resx/Home/Home.resx';
import StartSalesBannerModel from 'Js/api/v1/model/StartSalesBannerModel';
import BannerForm from './BannerForm';
import BannerSuccess from './BannerSuccess';

const BannerFormValidated = withValidation(BannerForm, [
    new Rule('.name', homeResx.BannerStartSalesModalFormNameEmpty, value =>
        Boolean(value)
    ),
    new Rule(
        '.name',
        homeResx.BannerStartSalesModalFormNameSymbolsLittle,
        value =>
            (value ? isLength(value, { min: 4 }) : true) || value.length == 0
    ),
    new Rule(
        '.name',
        homeResx.BannerStartSalesModalFormNameSymbolsMany,
        value => (value ? isLength(value, { max: 50 }) : true)
    ),
    new Rule(
        '.phoneNumber',
        homeResx.BannerStartSalesModalFormPhoneEmpty,
        ({ phoneNumber }) => Boolean(phoneNumber),
        true
    ),
    new Rule(
        '.phoneNumber',
        ({ phoneData }) =>
            cartResx.CartProfileFormValidatePhoneNumber.replace(
                '{0}',
                phoneData.exampleNumbers[0]
            ).replace('{1}', phoneData.exampleNumbers[1]),
        ({ phoneNumber, phoneData }) =>
            (phoneData?.isPossiblePhoneNumber &&
                phoneData?.isValidPhoneNumber) ||
            phoneNumber.length == 0,
        true
    )
]);

const StartSalesBanner = (): JSX.Element => {
    const [step, setStep] = useState(1);
    const [isloading, setIsLoading] = useState(false);
    const modalMode = step === 3 ? 'success' : null;

    const onCloseModal = () => setStep(1);

    const onSubmit = ({ name, phoneNumber }) => {
        setIsLoading(true);
        StartSalesBannerModel.post({ name, phoneNumber })
            .toPromise()
            .then(
                () => setStep(3),
                error => console.error('Error:', error)
            )
            .finally(() => setIsLoading(false));
    };

    return (
        <>
            <Button
                className="start-page-start-sales-banner__button"
                onClick={() => setStep(2)}
                blockSize="sm"
                theme="prime"
                uppercase
                framed
            >
                {homeResx.BannerStartSalesBtnText}
            </Button>
            {(step === 2 || step === 3) && (
                <Modal
                    mode={modalMode}
                    onClose={onCloseModal}
                    disabled={isloading}
                >
                    {step === 2 && (
                        <BannerFormValidated
                            onSubmit={(hasErrors, data) => {
                                if (!hasErrors) {
                                    onSubmit(data);
                                }
                            }}
                        />
                    )}
                    {step === 3 && <BannerSuccess onClose={onCloseModal} />}
                </Modal>
            )}
        </>
    );
};

export default StartSalesBanner;
